import type { IconProps } from '@crehana/compass.icons.outline/types';
import cn from 'clsx';

type TGridResumeCellProps = {
  title: string;
  value?: string;
  icon: React.ComponentType<IconProps>;
};

const GridResumeCell: React.FC<TGridResumeCellProps> = ({
  title,
  value,
  icon: Icon,
}) => {
  const hasValue = typeof value === 'string';

  return (
    <div
      role="gridcell"
      className="tw-p-1.2 tw-bg-neutral-light-200 hover:tw-bg-neutral-light-300 tw-transition-colors tw-duration-300 tw-rounded-0.4"
    >
      <div className="tw-flex sm:tw-flex-col tw-items-center tw-justify-center">
        <div
          className="tw-flex tw-items-center tw-justify-center tw-mr-0.4 sm:tw-mr-0 sm:tw-mb-0.8"
          aria-hidden
        >
          <Icon className="tw-fill-current" size={24} />
        </div>
        <div className="tw-flex tw-justify-center">
          <div
            className={cn(
              'tw-font-body5 tw-text-center tw-text-neutral-light-700',
              hasValue && 'tw-mr-0.4',
            )}
          >
            {title}
          </div>
          {hasValue && (
            <div className="tw-font-body5 tw-text-center tw-text-neutral-light-800">
              {value}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GridResumeCell;
